/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<f7d08d075c3cb5ee485bcde25548e595>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpLayoutHorizontalAlignment = "CENTER" | "LEFT" | "RIGHT" | "%future added value";
export type HelpLayoutVerticalAlignment = "BOTTOM" | "MIDDLE" | "TOP" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type alignmentSettingsContextFragment$data = {
  readonly alignment: {
    readonly __id: string;
    readonly horizontalAlignment: HelpLayoutHorizontalAlignment | null | undefined;
    readonly verticalAlignment: HelpLayoutVerticalAlignment | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "alignmentSettingsContextFragment";
};
export type alignmentSettingsContextFragment$key = {
  readonly " $data"?: alignmentSettingsContextFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"alignmentSettingsContextFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "alignmentSettingsContextFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutAlignmentSettings",
      "kind": "LinkedField",
      "name": "alignment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "horizontalAlignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "verticalAlignment",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpLayoutVisualConfig",
  "abstractKey": null
};

(node as any).hash = "e8bd7e9e63e3ee57f31e69ea25b912df";

export default node;
